(function(){
// Select the button element
const buttonDescription = document.querySelector('#open_description');
const buttonClose = document.querySelector('.description_close');
 /// Get the first element with the class 'product-description-long'
    const productDescription = document.querySelector(".product-description-long");
   console.log('click',productDescription);
    const ovely = document.querySelector(".overlay_product");
    const description_long = document.querySelector(".product-description-long");
    const htBody =  document.querySelector("body");
console.log(buttonDescription,'buttonDescription');

if(buttonDescription){

function truncateText() {
      var text = document.querySelector(".product__description ").innerHTML;         
  var truncated = text.substring(0,250) + "... </p>";
console.log('text',truncated);
document.querySelector(".product__description ").innerHTML = truncated;
}
  truncateText();
}

  if(buttonDescription){
// Add event listener for the button click
buttonDescription.addEventListener('click', () => {       
    // Check if the element exists
    if (productDescription) {
        productDescription.style.display = "";  // Reset the display style
        ovely.classList.add("active");
      description_long.classList.add("active");
      htBody.classList.add("overflow-hidden");
    }
    
   
});
    }
  if(buttonClose){
buttonClose.addEventListener('click', () => {
          
    // Check if the element exists
    if (productDescription) {
        productDescription.style.display = "none";  // Reset the display style
        ovely.classList.remove("active");
      description_long.classList.remove("active");
       htBody.classList.remove("overflow-hidden");
    }
    
   
});
    }
})();